<template>
    <div class="container">
        <div>
            <the-header v-if="!$route.meta.hideHeader"></the-header>

            <the-error
                v-if="error"
                :errorOff="errorOff"
                :status="status"
            ></the-error>

            <smart-banner v-if="!getIsTelegram" />
            <back-to-top-btn />

            <router-view />
            <!-- <router-view v-slot="{ Component }">
                <transition name="fade" mode="out-in">
                    <component :is="Component" />
                </transition>
            </router-view> -->
        </div>
        <the-footer v-if="!$route.meta.hideFooter" />
    </div>
    <!-- <promoModal v-if="isNOtLoggedIn" /> -->
    <ErrorNotConnnection v-if="!getConnetctionGlobal" />
    <global-loader v-if="getTelegramLoginPending" />
    <global-error v-if="getErrorGlobal" />
</template>

<script>
import { defineAsyncComponent } from "vue";
import { logoutLogin, checkToken, checkWorld } from "./Api";
import { mapGetters } from "vuex";
// import promoModal from "./components/promoModal/v2.vue";
const ErrorNotConnnection = defineAsyncComponent(() =>
    import("./components/ErrorNotConnection")
);
import globalLoader from "./components/GloabalLoader.vue";
const SmartBanner = defineAsyncComponent(() =>
    import("./components/SmartBanner")
);
const BackToTopBtn = defineAsyncComponent(() =>
    import("./components/BackToTopBtn")
);
const GlobalError = defineAsyncComponent(() =>
    import("./components/GlobalError")
);

const TheHeader = defineAsyncComponent(() =>
    import("./components/TheHeader.vue")
);
const TheError = defineAsyncComponent(() =>
    import("./components/TheError.vue")
);
const TheFooter = defineAsyncComponent(() =>
    import("./components/TheFooter.vue")
);
// const checkToken = () => import("./Api").then(module => module.checkToken);
// const checkWorld = () => import("./Api").then(module => module.checkWorld);
// const logoutLogin = () => import("./Api").then(module => module.logoutLogin);

export default {
    name: "App",

    data() {
        return {
            data: {
                janrId: "",
                provider: "",
            },
            isLoggedIn: false,
            isNOtLoggedIn: false,
            error: false,
            status: "",
            isWorld: true,
        };
    },

    components: {
        TheHeader,
        TheFooter,
        TheError,
        SmartBanner,
        BackToTopBtn,
        GlobalError,
        ErrorNotConnnection,
        globalLoader,
        // promoModal,
    },

    computed: {
        ...mapGetters([
            "getProviders",
            "getErrorGlobal",
            "getConnetctionGlobal",
            "getIsPromoActive",
            "getWorld",
            "getTelegramLoginPending",
            "getIsTelegram",
        ]),
    },

    created() {
        this.$store.commit("setCountries");
        this.$store.commit("setYears");

        this.$store.dispatch("fetchProviders");
        this.$store.dispatch("fetchGenres");

        this.$store.dispatch("getSeo");
        this.check();
    },
    mounted() {
        let check = localStorage.getItem("check2");

        if (!check) {
            localStorage.clear();
            localStorage.setItem("check2", true);
        }
        // window.addEventListener("load", () => {
        //     if (this.isWorld) return;
        //     this.$store.dispatch("checkPromo");
        // });
        this.getUTMSource();
    },

    beforeUnmount() {
        window.removeEventListener("load", () => {
            if (this.isWorld) return;
            this.$store.dispatch("checkPromo");
        });
    },

    watch: {
        $route(to, from) {
            if (to.name === "channel" && from.name === "channel") {
                // this.verifyAccess();
            }

            if (to.name === "newMovies" && from.name === "login") {
                this.$store.commit("updateMovieList", {
                    page: 1,
                    data: [],
                    query: {},
                });
            }

            this.verifyAccess();

            // if (to.name !== "newMovies" && to.name !== "movies") {
            //     if (window && to.name !== "channel") {
            //         window.scrollTo({ top: 0, behavior: "smooth" });
            //     }
            // }
        },
    },

    methods: {
        async fetch() {
            this.$store.commit("setIsLoadingStarted", true);
            let d = await checkWorld();
            if (d?.data.is_tasix == true) {
                this.$store.commit("setWorld", false);
                this.isWorld = false;
            } else {
                this.$store.commit("setWorld", true);
                this.isWorld = true;
            }
            this.$store.commit("setIsLoadingStarted", false);
        },
        async verifyAccess() {
            let token = localStorage.getItem("token");
            this.fetch();

            let response = await checkToken(token);
            if (response?.status === 0) {
                this.$store.commit("setAccess", true);
                this.isLoggedIn = true;
                this.isNOtLoggedIn = false;
            }
            if (response?.status === 1) {
                this.$store.commit("setAccess", false);
                this.isLoggedIn = false;
                this.isNOtLoggedIn = true;

                localStorage.removeItem("access");
                localStorage.removeItem("token");
            }
        },
        async check() {
            let token = localStorage.getItem("token");
            this.fetch();

            let response = await checkToken(token);
            if (response?.status === 0) {
                this.$store.commit("setAccess", true);
                this.isLoggedIn = true;
                this.isNOtLoggedIn = false;
            }
            if (response?.status === 1) {
                this.$store.commit("setAccess", false);
                this.isLoggedIn = false;
                this.isNOtLoggedIn = true;

                localStorage.removeItem("access");
                localStorage.removeItem("token");
            }
            this.telegramInit();
        },

        telegramInit() {
            if (window.Telegram && window.Telegram.WebApp.initData) {
                const tg = window.Telegram.WebApp;

                const initData = tg.initData;
                this.$store.commit("SET_TELEGRAM_INIT_DATA", initData);
                this.$store.commit("SET_IS_TELEGRAM", !!initData);
                const token = localStorage.getItem("token");
                if (!token) {
                    this.$store.commit("SET_TELEGRAM_LOGIN_PENDING", initData);
                    this.$store.dispatch("loginTg");
                }
                tg.ready();
                tg.expand();
            } else {
            }
        },

        async logout() {
            const response = await logoutLogin();

            if (response.error === 0) {
                localStorage.setItem("access", false);
                localStorage.removeItem("token");
                this.$store.commit("clearMovieList");
                this.$store.commit("SET_CLEAR_NOTIFICATIONS");
                this.$store.commit("SET_ALLREADY_ACTIVATE_ONE_SUM", true);
                this.$store.commit("SET_USER_INFO", null);
                this.$store.commit("RESET_UZBLIST");
                this.$router.go("/");
                this.isLoggedIn = false;
            }
        },
        getUTMSource() {
            let url = new URL(window.location.href);
            let source = url.searchParams.get("utm_source");
            let medium = url.searchParams.get("utm_medium");
            let campaign = url.searchParams.get("utm_campaign");
            if (!source || !medium || !campaign) {
                return;
            }
            document.cookie = `utm_source=${source}; max-age=31536000; path=/`;
            document.cookie = `utm_medium=${medium}; max-age=31536000; path=/`;
            document.cookie = `utm_campaign=${campaign}; max-age=31536000; path=/`;
            return source;
        },
        errorOff() {
            this.error = false;
        },

        errorOn() {
            this.error = true;
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>

<style scoped>
.container {
    height: 100%;
    min-height: 100dvh;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
}
</style>
